import React from "react";

const GeneralSettingsRow = (props: any) => {
    const { vesselMachinery, index } = props;
    const handleGenralSettingsCommon = (e: any, settings: string) => {
        vesselMachinery[settings] = e.target.checked;
    }

    return (
        <tr key={vesselMachinery.id}>
            <td>{vesselMachinery.vessel_machinery_name}</td>
            <td>{vesselMachinery.machinery}</td>
            <td>
                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`running_hrs${index}`}
                        name='running_hour'
                        defaultChecked={vesselMachinery.running_hour}
                        onChange={(e) => handleGenralSettingsCommon(e, 'running_hour')}
                    />
                </div>
            </td>
            <td>
                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`energy_param${index}`}
                        defaultChecked={vesselMachinery.energy_parameter}
                        onChange={(e) => handleGenralSettingsCommon(e, 'energy_parameter')}
                    />
                </div>
            </td>
            <td>
                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`SFOC${index}`}
                        defaultChecked={vesselMachinery.sfoc_required}
                        onChange={(e) => handleGenralSettingsCommon(e, 'sfoc_required')}
                    />
                </div>
            </td>
            <td>
                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`egcs${index}`}
                        defaultChecked={vesselMachinery.is_egcs}
                        onChange={(e) => handleGenralSettingsCommon(e, 'is_egcs')}
                    />
                </div>
            </td>
            <td>
                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`scr_egr${index}`}
                        defaultChecked={vesselMachinery.is_scr_or_egr}
                        onChange={(e) => handleGenralSettingsCommon(e, 'is_scr_or_egr')}
                    />
                </div>
            </td>
        </tr>
    )
}

export default GeneralSettingsRow